/**
 * Synthetic challenge row for a guest Monkey slip saved locally (not yet in DB).
 */

/** Prefix for per-slip ids: `guest_pending_monkey_<localId>`. */
export const GUEST_PENDING_MONKEY_CHALLENGE_ID_PREFIX = 'guest_pending_monkey_' as const;

/** Legacy single-card id (persisted tests / old builds). */
export const GUEST_PENDING_MONKEY_CHALLENGE_ID = 'guest_pending_monkey_challenge' as const;

export function guestPendingMonkeyArenaChallengeIdFromLocalId(localId: string): string {
  return `${GUEST_PENDING_MONKEY_CHALLENGE_ID_PREFIX}${localId}`;
}

export function isGuestPendingMonkeyArenaChallengeId(id: string): boolean {
  return id === GUEST_PENDING_MONKEY_CHALLENGE_ID || id.startsWith(GUEST_PENDING_MONKEY_CHALLENGE_ID_PREFIX);
}

/** Main CTA on the synthetic Arena card for a guest-only Monkey slip. */
export const GUEST_PENDING_ARENA_PRIMARY_CTA = 'Sign up to lock in' as const;
